import styled from 'styled-components';

interface ItemProps {
  readonly max?: string;
  readonly size?: string;
  readonly mRight?: string;
  readonly fontSize?: string;
  readonly padding?: string;
}

export const Media = styled.div<ItemProps>`
  display: flex;
  align-items: center;
  padding-left: ${props => props.padding};
`;

export const MediaImg = styled.div<ItemProps>`
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.2);
  background-color: #fafafa;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  margin-right: ${props => props.mRight};
  height: ${props => props.size};
  width: ${props => props.size};
  & img {
    display: inline-block;
    object-fit: cover;
    width: 100%;
  }
`;

export const MediaBody = styled.div<ItemProps>`
  color: #5d6e81;

  font-weight: 500;

  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${props => {
    if (props.max) {
      return `
        max-width: ${props.max};
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      `;
    }
    if (props.fontSize) {
      return `
     font-size: ${props.fontSize};
      `;
    }
  }}
`;
